var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hotelCommentBox"},[_c('dl',{staticClass:"hotelCommentBoxItem flexLeft"},[_c('dt',[_vm._v("評価点（平均）")]),_c('dd',{staticClass:"fontNo"},[_c('span',[_vm._v(_vm._s(_vm.averageRating))]),_vm._v(" / 5 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }